﻿<template>
    <q-form ref="innerForm" v-bind="$attrs">
        <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope || {}" />
        </template>
    </q-form>
</template>

<script setup lang="ts">
import { provide, ref, watch } from "vue"

const selectors = 'input:enabled,textarea:enabled,select:enabled,button:not(.qe-ignore-focus)'

const innerForm = ref<any>()

const validate = () => {
    // Support both component instance with validate() and plain element when stubbed
    return innerForm.value?.validate ? innerForm.value.validate() : true
}

defineExpose( { validate } )

const focusNextCounter = ref( 0 )
const focusResetCounter = ref( 0 )

provide( 'focusNextCounter', focusNextCounter )
provide( 'focusResetCounter', focusResetCounter )

watch( focusNextCounter, () => {
    const hostEl: any = innerForm.value?.$el ?? innerForm.value
    if ( !hostEl ) return
    const inputs = Array.from( hostEl.querySelectorAll( selectors ) )

    if ( inputs.length == 0 )
        return

    let current = inputs.indexOf( document.activeElement as any )

    if ( ++current >= inputs.length )
        current = 0

    ;( inputs[ current ] as HTMLElement ).focus()
} )

watch( focusResetCounter, () => {
    const hostEl: any = innerForm.value?.$el ?? innerForm.value
    if ( !hostEl ) return
    const inputs = Array.from( hostEl.querySelectorAll( selectors ) )

    if ( inputs.length == 0 )
        return

    ;( inputs[ 0 ] as HTMLElement ).focus()
} )
</script>
